/**
 * Labstep
 *
 * @module components/UserOrganization/Action/AddBulkUsers/CreateUsers
 * @desc Adding bulk users
 */

import { GridCreateUsers } from 'labstep-web/grid/CreateUsers';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { OrganizationPlan } from 'labstep-web/models/organization-plan.model';
import type React from 'react';
import type { CreateUsersProps } from './types';

export const UserOrganizationActionAddBulkUsersCreateUsers: React.FC<
  CreateUsersProps
> = ({ organization, ...rest }) =>
  organization.is_sync_stripe_enabled ? (
    <ReadOnMountHOC
      type="entity"
      id={organization.id}
      entityName={OrganizationPlan.entityName}
      loading={{
        cached: true,
        loader: 'placeholder',
      }}
      children={({ entity }) => (
        <GridCreateUsers
          organization={organization}
          organizationPlan={entity}
          {...rest}
        />
      )}
    />
  ) : (
    <GridCreateUsers organization={organization} {...rest} />
  );
